var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRupee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.05469 3.46094L7.66406 4.90625H0.320312L0.71875 3.46094H8.05469ZM4.39844 12L0.546875 7.45312L0.539062 6.20312H2.39844C2.85156 6.20312 3.22396 6.11979 3.51562 5.95312C3.8125 5.78125 4.03385 5.54948 4.17969 5.25781C4.33073 4.96615 4.40625 4.63802 4.40625 4.27344C4.40625 3.89323 4.33854 3.55729 4.20312 3.26562C4.06771 2.96875 3.85156 2.73698 3.55469 2.57031C3.25781 2.40365 2.86458 2.32031 2.375 2.32031H0.328125L0.773438 0.625H2.375C3.30208 0.625 4.07292 0.765625 4.6875 1.04688C5.30729 1.32292 5.77083 1.72656 6.07812 2.25781C6.39062 2.78385 6.54688 3.41927 6.54688 4.16406C6.54688 4.8151 6.4375 5.39062 6.21875 5.89062C6.00521 6.38542 5.65885 6.78906 5.17969 7.10156C4.70052 7.41406 4.07031 7.6224 3.28906 7.72656L6.78125 11.8906V12H4.39844ZM8.0625 0.625L7.66406 2.07031H1.625L2.02344 0.625H8.0625ZM14.5234 0.59375V12H12.4531V3.00781L9.71094 3.91406V2.24219L14.2891 0.59375H14.5234Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRupee);
export default __webpack_public_path__ + "static/media/rupee.a811c78ee0be49dba59ab83360e32f89.svg";
export { ForwardRef as ReactComponent };